export var TimeRangeEnum;
(function (TimeRangeEnum) {
    TimeRangeEnum["ONE_DAY"] = "ONE_DAY";
    TimeRangeEnum["ONE_WEEK"] = "ONE_WEEK";
    TimeRangeEnum["ONE_MONTH"] = "ONE_MONTH";
    TimeRangeEnum["THREE_MONTHS"] = "THREE_MONTHS";
    TimeRangeEnum["SIX_MONTHS"] = "SIX_MONTHS";
    TimeRangeEnum["ONE_YEAR"] = "ONE_YEAR";
    TimeRangeEnum["CURRENT_YEAR"] = "CURRENT_YEAR";
})(TimeRangeEnum || (TimeRangeEnum = {}));
//# sourceMappingURL=time-range.enum.js.map